"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPE = void 0;

var _reactToastify = require("react-toastify");

const TYPE = {
  ERROR: "error",
  WARNING: "warn",
  INFO: "info",
  SUCCESS: "success"
};
exports.TYPE = TYPE;

const customToast = (type, text) => {
  if (!type || !text) return false;

  _reactToastify.toast[type](text, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  });
};

var _default = customToast;
exports.default = _default;